import styled from 'styled-components';
import { Dropdown } from 'antd';

export const StyledDropdown = styled(Dropdown)``;
